import { useNotifications } from 'providers/notifications/useNotifications';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetTitanDataMutation } from 'services/merchants';

import { NotificationSeverity } from 'types/notifications';

import { LABELS } from './keys';

type ReactToolkitError = {
  data?: { errorMessage?: string };
};

export const useTitanData = ({ shift4MerchantId, includeAllOwners }: { shift4MerchantId?: string | null; includeAllOwners?: boolean }) => {
  const { t } = useTranslation();
  const { pushToast } = useNotifications();

  const [getTitanData, { data: titanData, isLoading: isLoadingTitanData }] = useGetTitanDataMutation();

  const fetchTitanData = useCallback(async () => {
    if (!shift4MerchantId) return;

    const titanResult = await getTitanData({ uuid: shift4MerchantId, includeAllOwners });
    if ('error' in titanResult) {
      const errorMessage = (titanResult.error as ReactToolkitError)?.data?.errorMessage;
      const message = typeof errorMessage === 'string' ? errorMessage : t(LABELS.PANEL_VALUES.TITAN_DATA_NOT_AVAILABLE);

      pushToast({
        severity: NotificationSeverity.error,
        message,
      });
    }
  }, [shift4MerchantId, includeAllOwners, getTitanData, pushToast, t]);

  return { fetchTitanData, titanData, isLoadingTitanData };
};
